<template>
    <li class="m-nav__item m-topbar__quick-actions m-topbar__quick-actions--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-right m-dropdown--align-push m-dropdown--mobile-full-width m-dropdown--skin-light"  m-dropdown-toggle="click">
        <div class="btn-group m-nav__link">
            <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{locale}}
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" @click="changeLanguage('en')">
                    {{$t('English')}}
                </a>
                <a class="dropdown-item" @click="changeLanguage('hu')">
                    {{$t('Magyar')}}
                </a>
            </div>
        </div>
    </li>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  computed: {
    locale: {
      get: function () {
        if (this.$store.state.loading.language === 'hu') {
          return this.$translate.t('Magyar')
        } else {
          return this.$translate.t('English')
        }
      },
      set: function (val) {
        return this.$store.state.loading.language
      }
    }
  },
  methods: {
    changeLanguage (lang) {
      this.$translate.setLocaleMessage(lang, this.$store.state.loading.languages[lang])
      this.$translate.locale = lang
      this.$store.commit('loading/changeLanguage', lang)

      if (lang === 'hu') {
        this.locale = this.$translate.t('Magyar')
      } else {
        this.locale = this.$translate.t('English')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/header/LanguageSwitcher.vue